import * as yup from 'yup';

import { requiredNumberField } from '@blockpulse3/web-client/forms';

import { SubscriptionDetailsInvestAmountForm } from './type';

export const schema = yup.object({
  amount: requiredNumberField,
}) as yup.ObjectSchema<SubscriptionDetailsInvestAmountForm>;
